import React, { useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft } from "react-icons/fa";
import styles from "./PurchasePage.module.scss";
import { useNavigate } from "react-router-dom";
import { route } from "../../static/route";
import { toast } from "react-toastify";
import { toastStyles } from "../../static/styles";
import { POST } from "../../services/axios.service";
import { IPurchaseFormInput } from "../../types/purchase";
import PurchaseForm from "../../components/purchase/PurchaseForm";

const PurchaseCreatePage = () => {
  
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGoBack = () => {
    navigate(route.purchase);
  };

  const handleSubmit = async (data: IPurchaseFormInput) => {
    setIsSubmitting(true);
    try {
      await POST("/v1/admin/purchases", {
        party_id: data.party_id,
        date: data.date,
        voucher_no: data.voucher_no,
        discount: data.discount,
        tax_percentage: data.tax_percentage,
        tax: data.tax,
        items: data.items,
      })
        .then((response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
            navigate(route.purchase);
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className={styles.PurchasePage}>
        <div className="logoSection">
          <h1
            onClick={handleGoBack}
            className="text-5xl font-bold text-white lg:text-3xl cursor-pointer lg:w-fit"
          >
            કનૈયા પ્લેટિંગ
          </h1>
          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>

        <div className="pageTitleSection">
          <FaArrowLeft
            onClick={handleGoBack}
            className="lg:hidden absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />
          <h1 className="text-5xl mt-6 lg:mt-0 font-bold text-white lg:text-2xl lg:text-primary-1">
            નવી ખરીદી ઉમેરો
          </h1>
        </div>

        <div className="mt-[60px] px-10 py-5">
          <div className="lg:bg-white lg:shadow lg:rounded-md lg:p-6 mt-8">
            <PurchaseForm
              onSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              onCancel={handleGoBack}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PurchaseCreatePage;
